import React, { FC, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DraggableProvidedDragHandleProps } from 'react-beautiful-dnd';
import { Block, BlockType } from '../../../../../../config/api/models/Block';
import {
  ConfirmationDialog,
  DraggableItem,
  DraggableItemIcon,
  Icons,
  ManagedBlankInput,
  SvgIcon,
} from '../../../../../shared/components';
import { getIconByType } from '../../../../helpers';
import { Page } from '../../../../../../config/api/models/Page';
import { useAppDispatch } from '../../../../../shared/hooks/useAppDispatch';
import { setHoverBlock } from '../../../../../shared/slices/blocks/entity/BlocksSlice';
import { deleteBlock, patchBlock } from '../../../../../shared/slices/blocks/api/blocks';
import { styled } from '@material-ui/core';

type Props = {
  page?: Page;
  block: Block;
  bookId: string;
  dragHandleProps?: DraggableProvidedDragHandleProps;
};

const Content = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'left',
  width: '100%',
});

const Icon = styled(SvgIcon)({
  margin: 'auto 1rem',
});

const StyledManagedBlankInput = styled(ManagedBlankInput)({
  height: '100%',
});

const BlocksListItem: FC<Props> = ({ page, block, bookId, dragHandleProps }) => {
  const [openConfirmDelete, setOpenConfirmDelete] = useState(false);
  const { t } = useTranslation();
  const postFix = [
    <DraggableItemIcon
      component="button"
      icon={Icons.DELETE}
      onClick={() => setOpenConfirmDelete(true)}
    />,
  ];

  const dispatch = useAppDispatch();

  const handleChangeTitle = useCallback(
    (title: string) => {
      if (title === block.title) return;
      if (!!page) {
        dispatch(
          patchBlock({
            pageId: page.id,
            blockId: block.id,
            bookId,
            payload: { title },
          })
        );
      }
    },
    [page, block, bookId, dispatch]
  );

  const handleCloseConfirm = (result: boolean) => {
    if (result) {
      dispatch(deleteBlock({ bookId, pageId: page!.id, blockId: block.id }));
    }
    setOpenConfirmDelete(false);
  };

  return (
    <>
      <DraggableItem
        postfix={postFix}
        dragHandleProps={dragHandleProps}
        onMouseEnter={() => dispatch(setHoverBlock(block.id))}
        onMouseLeave={() => dispatch(setHoverBlock(undefined))}
      >
        <Content>
          <Icon
            viewBox={block.type === BlockType.COLUMN ? '0 0 512 512' : undefined}
            large
            icon={getIconByType(block.type as BlockType)}
          />
          <StyledManagedBlankInput
            flex={1}
            value={block.title || t(`trajectory.page.blocks.${block.type}.title`)}
            onChange={handleChangeTitle}
            ellipsis
          />
        </Content>
      </DraggableItem>
      {/*block.childBlocks && block.childBlocks.length > 0 && (
        <Paper
          elevation={3}
          style={{ marginLeft: '4.5rem', marginRight: '3.6rem', marginBottom: '1rem' }}
          square
        >
          <List
            dense
            style={{
              position: 'relative',
              overflow: 'auto',
              maxHeight: 150,
              margin: 0,
            }}
          >
            {block.childBlocks.map((b) => (
              <ListItem style={{ paddingLeft: 0 }}>
                <ListItemIcon style={{ minWidth: 0 }}>
                  <Icon
                    viewBox={b.type === BlockType.COLUMN ? '0 0 512 512' : undefined}
                    large
                    icon={getIconByType(b.type as BlockType)}
                  />
                </ListItemIcon>
                <ListItemText style={{ paddingLeft: '0 !important' }} secondary={b.title} />
              </ListItem>
            ))}
          </List>
        </Paper>
            )*/}
      <ConfirmationDialog
        open={openConfirmDelete}
        title={t('trajectory.sidebar.pageManagement.confirmDelete.title')}
        description={t('trajectory.sidebar.pageManagement.confirmDelete.description')}
        onClose={handleCloseConfirm}
      />
    </>
  );
};

export default BlocksListItem;
